<template>
  <div class="overlay-loader" role="alert" aria-live="assertive">
    <div class="loader-wrapper">
      <img :src="loaderIcon" alt="Loading..." class="rotating" />
      <p class="loader-text">
        Processing your request
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import loaderIcon from '@/assets/Ellipse.svg'
</script>

<style scoped>
.overlay-loader {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.6);
}

.loader-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 24px;
}

.rotating {
  width: 160px;
  height: 160px;
  animation: spin 1s linear infinite;
}

.loader-text {
  color: #333;
  font-size: 24px;
  font-weight: var(--font-weight-bold);
}

@media (max-width: 480px) {
  .overlay-loader {
    align-items: flex-start;
  }

  .loader-wrapper {
    margin-top: 144px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
